import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";

import axiosInstance from "../../Api/Axios";
import { useLoader } from "../../Context/LoaderContext";

import { addSeparateur } from "../../Functions/separateur_chiffre";

import bgSidebarRight from "./../../Images/bg_sidebar_right.png";
import bgSidebarMobilier from "./../../Images/bg_sidebar_mobilier.png";
import bgSidebarImmobilier from "./../../Images/bg_sidebar_immobilier.png";

import "./SidebarRightFinancingRequest.scss";

const SidebarRightFinancingRequest = () => {
  const [dataSimulation, setDataSimulation] = React.useState([]);

  const { setIsLoading } = useLoader();
  const { id } = useParams();
  React.useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/simulation/${id}/show`)
      .then((response) => {
        setIsLoading(false);
        setDataSimulation(response.data.data.simulation || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [id, setIsLoading]);

  // A rendre Dynamique
  const propertyType = dataSimulation.product_name;

  return (
    <div className="wrap-sidebar-right">
      <div className="header-sidebar-right-notConnected">
        <img
          src={
            propertyType === "immobilier"
              ? bgSidebarImmobilier
              : propertyType === "mobilier"
              ? bgSidebarMobilier
              : bgSidebarRight
          }
          alt=""
          style={{ maxWidth: "100%", width: "100%" }}
        />
      </div>

      <div className="content-sidebar-right-notConnected connected-sidebar">
        <div className="title-content-sidebar-right">
          Résultat de la simulation
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">
            Montant du loyer par mois
          </div>
          <div className="txt-content-sidebar-right price-sidebar">
            {addSeparateur(dataSimulation.result_amount) || "-"} TND
          </div>
          <p>Le taux appliqué au niveau du site est à titre indicatif</p>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">
            Type de bien à financer
          </div>
          <div className="txt-content-sidebar-right text-capitalize">
            {dataSimulation.product_name}
          </div>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">Montant</div>
          <div className="txt-content-sidebar-right">
            {addSeparateur(dataSimulation?.amount) || "-"} TND
          </div>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">Autofinancement</div>
          <div className="txt-content-sidebar-right">
            {addSeparateur(dataSimulation?.self_financing) || "-"} TND
          </div>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">Durée</div>
          <div className="txt-content-sidebar-right">
            {dataSimulation?.duration || "-"} Mois
          </div>
        </div>
      </div>

      <div className="footer-sidebar-right-notConnected">
        Assurez-vous de remplir chaque champ avec précision pour éviter tout
        retard dans le traitement de votre demande.
      </div>
    </div>
  );
};

export default SidebarRightFinancingRequest;
